"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line max-len
var Close = function Close() {
  return _react2.default.createElement(
    "svg",
    {
      width: "13",
      height: "13",
      viewBox: "0 0 13 13"
    },
    _react2.default.createElement("path", {
      fill: "#000",
      fillRule: "evenodd",
      d: "M7.206 6.5L12.855.851a.502.502 0 0 0 0-.706.505.505 0 0 0-.706\n        0L6.5 5.794.851.145a.502.502 0 0 0-.706 0 .505.505 0 0 0 0\n        .706L5.794 6.5.145 12.149a.502.502 0 0 0 0 .706c.19.189.511.195.706 0L6.5\n        7.206l5.649 5.649a.502.502 0 0 0 .706 0 .505.505 0 0 0 0-.706L7.206 6.5z"
    })
  );
};

exports.default = Close;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CloseIcon/CloseIcon.js
// module id = 276
// module chunks = 0